import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type {
	BuildingSavingsCreateFormInput,
	BuildingSavingsEditFormInput,
} from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";

const BUILDING_SAVINGS_FORM_BASE_DEFAULT_VALUES: BuildingSavingsEditFormInput =
	{
		name: "",
		contractNumber: "",
		producer: "",
		product: "",
		signedAt: null,
		startAt: null,
		endAt: null,
		payment: null,
		paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
		appreciation: null,
		targetAmount: null,
	};

export const BUILDING_SAVINGS_EDIT_FORM_DEFAULT_VALUES: BuildingSavingsEditFormInput =
	BUILDING_SAVINGS_FORM_BASE_DEFAULT_VALUES;

export const getBuildingSavingsCreateFormDefaultValues =
	(): BuildingSavingsCreateFormInput => ({
		...BUILDING_SAVINGS_FORM_BASE_DEFAULT_VALUES,
		currentValue: null,
		totalInvested: null,
		valueDate: new Date(),
	});
